var moduleMap = {
	"./ConfirmationRoleAction": () => {
		return Promise.all([__webpack_require__.e(1532), __webpack_require__.e(4372)]).then(() => (() => ((__webpack_require__(4372)))));
	},
	"./ContrastReactQueryProvider": () => {
		return Promise.all([__webpack_require__.e(1532), __webpack_require__.e(59), __webpack_require__.e(8959), __webpack_require__.e(9651), __webpack_require__.e(6980)]).then(() => (() => ((__webpack_require__(6980)))));
	},
	"./MockContrastAPI": () => {
		return Promise.all([__webpack_require__.e(274), __webpack_require__.e(1532), __webpack_require__.e(7269)]).then(() => (() => ((__webpack_require__(7269)))));
	},
	"./MockContrastUI": () => {
		return Promise.all([__webpack_require__.e(274), __webpack_require__.e(1532), __webpack_require__.e(59), __webpack_require__.e(8959), __webpack_require__.e(5330), __webpack_require__.e(9651), __webpack_require__.e(936), __webpack_require__.e(6939)]).then(() => (() => ((__webpack_require__(6939)))));
	},
	"./MockContrastUser": () => {
		return Promise.all([__webpack_require__.e(1532), __webpack_require__.e(5330), __webpack_require__.e(2665)]).then(() => (() => ((__webpack_require__(2665)))));
	},
	"./Modals": () => {
		return Promise.all([__webpack_require__.e(9785), __webpack_require__.e(1532), __webpack_require__.e(59), __webpack_require__.e(4653), __webpack_require__.e(2616), __webpack_require__.e(5629), __webpack_require__.e(1907), __webpack_require__.e(3641)]).then(() => (() => ((__webpack_require__(3641)))));
	},
	"./RoleSwitch": () => {
		return Promise.all([__webpack_require__.e(1532), __webpack_require__.e(9797)]).then(() => (() => ((__webpack_require__(9797)))));
	},
	"./SendToEmailModal": () => {
		return Promise.all([__webpack_require__.e(9785), __webpack_require__.e(1532), __webpack_require__.e(59), __webpack_require__.e(4653), __webpack_require__.e(2616), __webpack_require__.e(5629), __webpack_require__.e(1907), __webpack_require__.e(252)]).then(() => (() => ((__webpack_require__(252)))));
	},
	"./ServerEnvironment": () => {
		return __webpack_require__.e(4329).then(() => (() => ((__webpack_require__(4329)))));
	},
	"./Tags": () => {
		return __webpack_require__.e(2369).then(() => (() => ((__webpack_require__(2369)))));
	},
	"./Translations": () => {
		return __webpack_require__.e(7186).then(() => (() => ((__webpack_require__(7186)))));
	},
	"./accessControl": () => {
		return Promise.all([__webpack_require__.e(5330), __webpack_require__.e(3538)]).then(() => (() => ((__webpack_require__(3538)))));
	},
	"./filters": () => {
		return Promise.all([__webpack_require__.e(8055), __webpack_require__.e(1532), __webpack_require__.e(59), __webpack_require__.e(8959), __webpack_require__.e(8120), __webpack_require__.e(5629), __webpack_require__.e(1907), __webpack_require__.e(936), __webpack_require__.e(1719), __webpack_require__.e(7123)]).then(() => (() => ((__webpack_require__(7123)))));
	},
	"./layout": () => {
		return Promise.all([__webpack_require__.e(8055), __webpack_require__.e(1532), __webpack_require__.e(59), __webpack_require__.e(8959), __webpack_require__.e(8120), __webpack_require__.e(5629), __webpack_require__.e(1907), __webpack_require__.e(1719), __webpack_require__.e(3267)]).then(() => (() => ((__webpack_require__(3267)))));
	},
	"./state": () => {
		return Promise.all([__webpack_require__.e(5330), __webpack_require__.e(5379)]).then(() => (() => ((__webpack_require__(5379)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});